import React from 'react';
import { Field, Form, ErrorMessage, Formik } from 'formik';
import * as Yup from 'yup';
import { TextField, Button } from '@mui/material';

const CadastroAnuncianteForm1 = ({ initialValues, onSubmit }) => {

    const validationSchema = Yup.object().shape({
        cnpj: Yup.string()
            .required('Preencha o CNPJ'),
        inscricaoEstadual: Yup.string()
            .required('Preencha a Inscrição Estadual da empresa'),
        nomeFantasia: Yup.string()
            .required('Preencha o nome fantasia da empresa'),
        razaoSocial: Yup.string()
            .required('Preencha a razão social da empresa'),
        website: Yup.string()
            .url('Insira um URL válido')
            .required('Preencha o website'),
        telefoneEmpresa: Yup.string()
            .required('Preencha o telefone'),
    });

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
        >
            {({ isSubmitting }) => (
                <Form>
                    <Field
                        name="cnpj"
                        as={TextField}
                        fullWidth
                        label="Digite seu CNPJ"
                        variant="outlined"
                        size="small"
                        error={Boolean(ErrorMessage.name)}
                        helperText={<ErrorMessage name="cnpj" />}
                    />
                    <Field
                        name="inscricaoEstadual"
                        as={TextField}
                        fullWidth
                        label="Inscrição Estadual"
                        variant="outlined"
                        size="small"
                        error={Boolean(ErrorMessage.name)}
                        helperText={<ErrorMessage name="inscricaoEstadual" />}
                    />
                    <Field
                        name="nomeFantasia"
                        as={TextField}
                        fullWidth
                        label="Nome fantasia"
                        variant="outlined"
                        size="small"
                        error={Boolean(ErrorMessage.name)}
                        helperText={<ErrorMessage name="nomeFantasia" />}
                    />
                    <Field
                        name="razaoSocial"
                        as={TextField}
                        fullWidth
                        label="Razão Social"
                        variant="outlined"
                        size="small"
                        error={Boolean(ErrorMessage.name)}
                        helperText={<ErrorMessage name="razaoSocial" />}
                    />
                    <Field
                        name="website"
                        as={TextField}
                        fullWidth
                        label="Website"
                        variant="outlined"
                        size="small"
                        error={Boolean(ErrorMessage.name)}
                        helperText={<ErrorMessage name="website" />}
                    />
                    <Field
                        name="telefoneEmpresa"
                        as={TextField}
                        fullWidth
                        label="Telefone"
                        variant="outlined"
                        size="small"
                        error={Boolean(ErrorMessage.name)}
                        helperText={<ErrorMessage name="telefoneEmpresa" />}
                    />
                    <Button
                        type="submit"
                        color="primary"
                        variant="contained"
                        disabled={isSubmitting}
                    >
                        Enviar
                    </Button>
                </Form>
            )}
        </Formik>
    );
};

export default CadastroAnuncianteForm1;
